const productdetailpageText = {
  color: "Renk: ",
  brand: "Marka: ",
  usage: "Kullanım Durumu: ",
  buy: "Satın Al",
  offer: "Teklif Ver",
  error: "Ürünü satın alabilmek için giriş yapmalısınız",
  sold: "Bu Ürün Satışta Değil",
  explain: "Açıklama",
  cancelOffer: "Teklifi Geri Çek",
};

export default productdetailpageText;
